import AnomalityBadge from './AnomalityBadge';
import PostMeta from './PostMeta';
import { truncateText } from '../utils/formatUtils';



const Post = ({ post, onClick, togglePostText, expandedPosts }) => {
    const postId = `${post.group_id}-${post.id}`;
    const isExpanded = expandedPosts[postId];
  
    return (
      <div className="source-data-post" onClick={() => onClick(post)}>
        <div className="source-data-post-header">
          <p onClick={(e) => { e.stopPropagation(); togglePostText(postId); }}>
            {isExpanded ? post.text : truncateText(post.text)}
            {post.text.split(' ').filter((word) => word.length > 0).length > 10 && (
              <span className="source-data-read-more">
                {isExpanded ? ' Свернуть' : ' Читать далее'}
              </span>
            )}
          </p>
          {post.text_anomality !== null && (
            <AnomalityBadge anomality={post.text_anomality} size="small" />
          )}
        </div>
        <PostMeta post={post} />

      </div>
    );
  };

export default Post;